import { render } from "./add-children.vue?vue&type=template&id=4a5b567c"
import script from "./add-children.vue?vue&type=script&lang=js"
export * from "./add-children.vue?vue&type=script&lang=js"

import exportComponent from "/home/Work/max/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__